import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Button, Label, FormGroup, Spinner } from "reactstrap";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import { AvForm } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";

import { BaseUrl } from "../../helpers/Baseurl"
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { createSlugfromName } from "../../helpers/methods";
import { isEmpty } from "lodash";

var include_id = 1
var exclude_id = 1

class ItineraryFooter extends Component {
    constructor(props) {
        super(props);
        this.obj = JSON.parse(localStorage.getItem("authUser"))
        if (!this.obj) {
            this.props.history.push('/logout')
        } else if (!validateToken(this.obj.access)) {
            this.props.history.push('/logout')
        }
        this.state = {
            includes: [],
            excludes: [],
            selectedIncludeCategory: { label: "--------", value: null },
            selectedExcludeCategory: { label: "--------", value: null },
            selectedTermsCondition: { label: "--------", value: "" },
            selectedSignature: { label: "--------", value: "" },
            CategoriesGroup: [],
            SignaturesGroup: []
        }

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
        }

        this.handleTremsSignatureSubmit = this.handleTremsSignatureSubmit.bind(this)
    }

    async componentDidMount() {
        document.title = "Terms & Conditions | Planmans"
        await this.loadItineraryData()
        await this.loadPackegeIncludeData()
        await this.loadPackegeExcludeData()
        await this.loadCategoryData()
        await this.loadSignatureData()
    }

    async loadItineraryData() {
        let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState({ itinerary: data })
                },

                (error) => {
                    console.log(error, 'error--------------')
                }
            )

    }

    async loadCategoryData() {

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(`${BaseUrl}/api/cms/categories/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {

                    let options = []
                    data.map(category => {
                        options.push({ label: category.name, value: category.id })
                    })

                    let CategoriesGroup = [
                        {
                            label: "Categories",
                            options: options
                        }
                    ];
                    this.setState({ CategoriesGroup })
                    this.loadFooterData()
                },
                (error) => {
                    console.log(error, 'error--------------')
                }
            )
    }

    async loadPackegeIncludeData() {
        let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(`${BaseUrl}/api/itineraries/itinerary-packege-include/?itinerary=${id}`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState({ includes: data })
                },

                (error) => {
                    console.log(error, 'error------')
                }
            )
    }

    async loadFooterData() {
        let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(`${BaseUrl}/api/itineraries/itinerary-footer-detail/${id}/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    const { CategoriesGroup } = this.state
                    let selectedTermsCondition = { label: "--------", value: "" }
                    let selectedSignature = { label: "--------", value: "" }
                    let category = CategoriesGroup[0].options
                    if (data.terms_condition) {
                        for (let i = 0; i < category.length; i++) {
                            if (data.terms_condition[0].category === category[i].value) {
                                selectedTermsCondition = category[i]
                            }
                        }
                    }
                    if (data.signature) {
                        selectedSignature = { label: data.signature.name, value: data.signature.id }
                    }
                    this.setState({ selectedTermsCondition, selectedSignature })

                },

                (error) => {
                    console.log(error, 'error--------------')
                }
            )

    }

    async loadSignatureData() {

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(`${BaseUrl}/api/cms/signatures/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = []
                    data.map(signature => {
                        options.push({ label: signature.name, value: signature.id })
                    })

                    let SignaturesGroup = [
                        {
                            label: "Signatures",
                            options: options
                        }
                    ];
                    this.setState({ SignaturesGroup: SignaturesGroup })
                },
                (error) => {
                    console.log(error, 'error--------------')
                }
            )
    }


    async loadPackegeExcludeData() {
        let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(`${BaseUrl}/api/itineraries/itinerary-packege-exclude/?itinerary=${id}`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState({ excludes: data })
                },

                (error) => {
                    console.log(error, 'error------')
                }
            )

    }

    handleAddIncludeRow() {
        const { includes } = this.state
        let newData = includes
        let newRow = { "id": `inc-${include_id}`, "point": "" }
        newData.push(newRow)
        include_id = include_id + 1
        this.setState({ includes: newData })

    }

    handleAddExcludeRow() {
        const { excludes } = this.state
        let newData = excludes
        let newRow = { "id": `exc-${exclude_id}`, "point": "" }
        newData.push(newRow)
        exclude_id = exclude_id + 1
        this.setState({ excludes: newData })

    }

    handleDeleteIncludeRow(id) {
        let new_id = "" + id
        const strFirstThree = new_id.substring(0, 3)
        if (strFirstThree === "inc") {
            let new_data = []
            for (let i = 0; i < this.state.includes.length; i++) {
                if (this.state.includes[i].id !== id) {
                    new_data.push(this.state.includes[i])
                }
            }

            this.setState({
                includes: new_data,
                activity_id: "",
                success_confirm: true,
                alert_confirm: false,
                dynamic_title: "Deleted!",
                dynamic_description: "Row has been deleted."
            })

        }
        else {
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${this.obj.access}` },
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-packege-include/${id}/`, requestOptions)
                .then(res => {
                    if (res.status >= 400) {
                        console.log("error")
                    }
                    else {
                        this.loadPackegeIncludeData()
                        this.setState({
                            activity_id: "",
                            success_confirm: true,
                            alert_confirm: false,
                            dynamic_title: "Deleted!",
                            dynamic_description: "Row has been deleted."
                        })
                    }
                }
                )
        }

    }

    handleDeleteExcludeRow(id) {
        let new_id = "" + id
        const strFirstThree = new_id.substring(0, 3)
        if (strFirstThree === "exc") {
            let new_data = []
            for (let i = 0; i < this.state.excludes.length; i++) {
                if (this.state.excludes[i].id !== id) {
                    new_data.push(this.state.excludes[i])
                }
            }

            this.setState({
                excludes: new_data,
                activity_id: "",
                exclude_success_confirm: true,
                exclude_alert_confirm: false,
                dynamic_title: "Deleted!",
                dynamic_description: "Row has been deleted."
            })

        } else {
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${this.obj.access}` },
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-packege-exclude/${id}/`, requestOptions)
                .then(res => {
                    if (res.status >= 400) {
                        console.log("error")
                    }
                    else {
                        this.loadPackegeExcludeData()
                        this.setState({
                            activity_id: "",
                            exclude_success_confirm: true,
                            exclude_alert_confirm: false,
                            dynamic_title: "Deleted!",
                            dynamic_description: "Row has been deleted."
                        })
                    }
                }
                )
        }

    }
    handleSelectedCategory = (selectedCategory, from) => {
        if (from === "Inclusition") {
            this.setState({ selectedIncludeCategory: selectedCategory, add_include_alert_confirm: true });
        } else {
            this.setState({ selectedExcludeCategory: selectedCategory, add_exclude_alert_confirm: true });
        }

    };

    handleSaveInclusition = row => {
        let itinerary_id = this.props.match.params.id
        let new_id = "" + row.id
        const strFirstThree = new_id.substring(0, 3)
        let includeData = { "point": row.point, "itinerary": itinerary_id }
        if (strFirstThree === "inc") {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                body: JSON.stringify(includeData)
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-packege-include/`, requestOptions)
                .then(res => {
                    if (res.status >= 400) {
                        this.loadPackegeIncludeData()

                    }
                    else {
                        this.loadPackegeIncludeData()
                    }
                }
                )

        } else {
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                body: JSON.stringify(includeData)
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-packege-include/${row.id}/`, requestOptions)
                .then(res => {
                    if (res.status >= 400) {
                        this.loadPackegeIncludeData()

                    }
                    else {
                        this.loadPackegeIncludeData()
                    }
                }
                )

        }
    }

    handleSaveExclusition = row => {
        let itinerary_id = this.props.match.params.id
        let new_id = "" + row.id
        const strFirstThree = new_id.substring(0, 3)
        let includeData = { "point": row.point, "itinerary": itinerary_id }
        if (strFirstThree === "exc") {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                body: JSON.stringify(includeData)
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-packege-exclude/`, requestOptions)
                .then(res => {
                    if (res.status >= 400) {
                        this.loadPackegeExcludeData()

                    }
                    else {
                        this.loadPackegeExcludeData()
                    }
                }
                )

        } else {
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                body: JSON.stringify(includeData)
            };
            fetch(`${BaseUrl}/api/itineraries/itinerary-packege-exclude/${row.id}/`, requestOptions)
                .then(res => {
                    if (res.status >= 400) {
                        this.loadPackegeExcludeData()

                    }
                    else {
                        this.loadPackegeExcludeData()
                    }
                }
                )

        }
    }

    AddDefaultExclusition() {
        const { selectedExcludeCategory } = this.state
        let id = this.props.match.params.id
        this.setState({ add_exclude_loding: true })
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };

        fetch(`${BaseUrl}/api/itineraries/delete-bulk-packege-exclude/${id}/`, requestOptions)
            .then(res => {
                if (res.status >= 400) {
                    this.loadPackegeIncludeData()
                    this.setState({

                        add_exclude_loding: false,
                        add_exclude_alert_confirm: false,
                    })
                }
                else {

                    fetch(`${BaseUrl}/api/itineraries/load-default-exclusition/${id}/${selectedExcludeCategory.value}/`, requestOptions)
                        .then(res => {
                            if (res.status >= 400) {
                                this.setState({

                                    add_exclude_loding: false,
                                    add_exclude_alert_confirm: false,
                                })
                            }
                            else {
                                this.loadPackegeExcludeData()
                                this.setState({
                                    add_exclude_loding: false,
                                    add_exclude_success_confirm: true,
                                    add_exclude_alert_confirm: false,
                                    dynamic_title: "Added!",
                                    dynamic_description: `${selectedExcludeCategory.label} Exclusition Added Successfully`
                                })
                            }
                        }
                        )

                }
            }
            )
    }

    AddDefaultInclusition() {
        const { selectedIncludeCategory } = this.state
        let id = this.props.match.params.id
        this.setState({ add_include_loding: true })
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        fetch(`${BaseUrl}/api/itineraries/delete-bulk-packege-include/${id}/`, requestOptions)
            .then(res => {
                if (res.status >= 400) {
                    this.loadPackegeIncludeData()
                    this.setState({

                        add_include_loding: false,
                        add_include_alert_confirm: false,
                    })
                }
                else {
                    fetch(`${BaseUrl}/api/itineraries/load-default-inclusition/${id}/${selectedIncludeCategory.value}/`, requestOptions)
                        .then(res => {
                            if (res.status >= 400) {
                                this.loadPackegeIncludeData()
                                this.setState({

                                    add_include_loding: false,
                                    add_include_alert_confirm: false,
                                })
                            }
                            else {
                                this.loadPackegeIncludeData()
                                this.setState({
                                    add_include_loding: false,
                                    add_include_success_confirm: true,
                                    add_include_alert_confirm: false,
                                    dynamic_title: "Added!",
                                    dynamic_description: `${selectedIncludeCategory.label} Inclusition Added Successfully`
                                })
                            }
                        }
                        )

                }
            }
            )
    }

    handleSelectedTermsCondition = selectedTermsCondition => {
        this.setState({ selectedTermsCondition })

    }
    handleSelectedSignature = selectedSignature => {
        this.setState({ selectedSignature })

    }

    handleTremsSignatureSubmit() {
        const { selectedSignature, selectedTermsCondition } = this.state
        this.setState({ loading: true })
        let data = { "terms_condition": selectedTermsCondition.value, 'signature': selectedSignature.value }
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
            body: JSON.stringify(data)
        };
        fetch(`${BaseUrl}/api/itineraries/itineraries/${this.props.match.params.id}/`, requestOptions)
            .then(res => {
                if (res.status >= 400) {
                    res.json()
                        .then(
                            (data) => {
                                console.log(data, "---data")
                                toastr.error("Something Went Wrong", "")
                                this.setState({ loading: false })
                            }
                        )
                }
                else {
                    this.setState({ loading: false })
                    toastr.success("Successfully Save", "")
                }
            }
            )



    }

    render() {

        let breadcrumbItems = [
            { title: "Itineraries", link: "/itineraries" },
            { title: this.state.itinerary?.name, link: `/itinerary-detail/${this.props.match.params.id}` },
            { title: "Packege Terms & Conditions", link: "#" },
        ]
        const PackegeIncludes = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },
            {
                dataField: "point",
                text: "Points",
                headerStyle: { backgroundColor: '#fcb92c', width: "90%" },
                formatter: (cellContent, row, col) => {
                    return (<p><b>PI{col + 1}. </b>{row.point}</p>)
                }
            },

            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row, col) => {
                    return (
                        <React.Fragment>
                            <Link to="#" onClick={() => this.setState({ activity_id: row.id, alert_confirm: true })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                        </React.Fragment>
                    )

                }
            },
        ]
        const PackegeExcludes = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },

            {
                dataField: "point",
                text: "Points",
                headerStyle: { backgroundColor: '#fcb92c', width: "90%" },
                formatter: (cellContent, row, col) => {
                    return (<p><b>PE{col + 1}. </b>{row.point}</p>)
                }
            },

            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row) => {
                    return (
                        <React.Fragment>
                            <Link to="#" onClick={() => this.setState({ activity_id: row.id, exclude_alert_confirm: true })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                        </React.Fragment>
                    )

                }
            },
        ]



        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>


                        <Breadcrumbs title={""} breadcrumbItems={breadcrumbItems} />
                        {!isEmpty(this.state.itinerary) ? (
                            <>
                                <Row>
                                    <div className="timeline-block my-3">
                                        <div className="time-show-btn mt-0">

                                            {has_Permission(this.obj.user, 1, 'edit') ?
                                                <Link to={`/itinerary-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Detail</Link>
                                                : null
                                            }

                                            {has_Permission(this.obj.user, 0, 'edit') ?
                                                <Link to={`/itinerary-daily-plan/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-clipboard-list font-size-15"></i> Itinerary Plan</Link>
                                                : null
                                            }

                                            {has_Permission(this.obj.user, 7, 'read') ?
                                                <Link to={`/itinerary-payment-detail/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-rupee-sign font-size-15"></i> Payments</Link>
                                                : null
                                            }

                                            {has_Permission(this.obj.user, 7, 'read') ?
                                                <Link to={`/invoices/${this.props.match.params.id}`} className="btn btn-link btn-rounded w-lg me-2"><i className="fas fa-file-invoice-dollar font-size-15"></i> Invoices</Link>
                                                : null}
                                            <Link to={`/itinerary/${this.state.itinerary.id}/${createSlugfromName(this.state.itinerary.name)}`} target="_blank" className="btn btn-link btn-rounded w-lg"><i className="far fa-eye font-size-15"></i> View Itinerary</Link>
                                        </div>
                                    </div>
                                </Row>


                                <Row>
                                    <Col xs={6}>
                                        <Card>
                                            <CardBody>
                                                <h4 className="card-title">{"Packege Includes"} </h4>
                                                <Row>
                                                    <Col md="6">
                                                        <div className="mb-3">
                                                            <Label className="form-label">Add default Inclusition</Label>
                                                            <Select
                                                                value={this.state.selectedIncludeCategory}
                                                                onChange={(e) => this.handleSelectedCategory(e, "Inclusition")}
                                                                options={this.state.CategoriesGroup}
                                                                classNamePrefix="select2-selection"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <BootstrapTable
                                                    keyField="id"
                                                    data={this.state.includes}
                                                    columns={PackegeIncludes}
                                                    cellEdit={cellEditFactory({
                                                        mode: 'dbclick',
                                                        blurToSave: true,
                                                        afterSaveCell: (oldValue, newValue, row, column) => { this.handleSaveInclusition(row) }
                                                    })}
                                                />

                                                <div style={{ textAlign: "center" }}>
                                                    <Button color="secondary" outline className="waves-effect me-1 mb-3 " onClick={() => this.handleAddIncludeRow()}>
                                                        Add New Detail
                                                    </Button>
                                                </div>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col xs={6}>
                                        <Card>
                                            <CardBody>
                                                <h4 className="card-title">{"Packege Excludes"} </h4>
                                                <Row>
                                                    <Col md="6">
                                                        <div className="mb-3">
                                                            <Label className="form-label">Add default Exclusitions</Label>
                                                            <Select
                                                                value={this.state.selectedExcludeCategory}
                                                                onChange={(e) => this.handleSelectedCategory(e, 'Exclusition')}
                                                                options={this.state.CategoriesGroup}
                                                                classNamePrefix="select2-selection"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <BootstrapTable
                                                    keyField="id"
                                                    data={this.state.excludes}
                                                    columns={PackegeExcludes}
                                                    cellEdit={cellEditFactory({
                                                        mode: 'dbclick',
                                                        blurToSave: true,
                                                        afterSaveCell: (oldValue, newValue, row, column) => { this.handleSaveExclusition(row) }
                                                    })}
                                                />

                                                <div style={{ textAlign: "center" }}>
                                                    <Button color="secondary" outline className="waves-effect me-1 mb-3 " onClick={() => this.handleAddExcludeRow()}>
                                                        Add New Detail
                                                    </Button>
                                                </div>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Card>
                                            <CardBody>
                                                <AvForm className="needs-validation" onValidSubmit={this.handleTremsSignatureSubmit} >
                                                    <Row>
                                                        <Col md="6">
                                                            <div className="mb-3">
                                                                <Label className="form-label">Terms & Condition</Label>
                                                                <Select
                                                                    menuPlacement="top"
                                                                    value={this.state.selectedTermsCondition}
                                                                    onChange={this.handleSelectedTermsCondition}
                                                                    options={this.state.CategoriesGroup}
                                                                    classNamePrefix="select2-selection"
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md="6">
                                                            <div className="mb-3">
                                                                <Label className="form-label">Signature</Label>
                                                                <Select
                                                                    menuPlacement="top"
                                                                    value={this.state.selectedSignature}
                                                                    onChange={this.handleSelectedSignature}
                                                                    options={this.state.SignaturesGroup}
                                                                    classNamePrefix="select2-selection"
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup className="mb-0">
                                                        {this.state.loading ? (
                                                            <Spinner className="me-2 mt-2" color="primary" />
                                                        ) : (
                                                            <div>

                                                                <Button type="submit" color="primary" className="me-1">
                                                                    Save
                                                                </Button>{" "}

                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </AvForm>

                                            </CardBody>
                                        </Card>
                                    </Col>

                                </Row>
                            </>) :
                            (
                                <div className="d-flex align-items-center justify-content-center min-vh-100">
                                    <Spinner type="grow" className="me-2" color="secondary" />
                                    <Spinner type="grow" className="me-2" color="secondary" />
                                    <Spinner type="grow" className="me-2" color="secondary" />
                                    <Spinner type="grow" className="me-2" color="secondary" />
                                </div>
                            )}

                    </Container>
                </div>
                {this.state.alert_confirm ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.handleDeleteIncludeRow(this.state.activity_id)}
                        onCancel={() =>
                            this.setState({
                                alert_confirm: false,
                                activity_id: "",

                            })
                        }
                    >
                        You won't be able to revert this!
                    </SweetAlert>
                ) : null}

                {this.state.success_confirm ? (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ success_confirm: false, alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                ) : null
                }
                {this.state.exclude_alert_confirm ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.handleDeleteExcludeRow(this.state.activity_id)}
                        onCancel={() =>
                            this.setState({
                                exclude_alert_confirm: false,
                                activity_id: "",

                            })
                        }
                    >
                        You won't be able to revert this!
                    </SweetAlert>
                ) : null}

                {this.state.exclude_success_confirm ? (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ exclude_success_confirm: false, exclude_alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                ) : null
                }
                {this.state.add_exclude_alert_confirm ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.AddDefaultExclusition()}
                        onCancel={() =>
                            this.setState({
                                add_exclude_alert_confirm: false,
                            })
                        }
                    >
                        You really want to add {this.state.selectedExcludeCategory.label} Exclusitions
                    </SweetAlert>
                ) : null}

                {this.state.add_exclude_success_confirm ? (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ add_exclude_success_confirm: false, add_exclude_alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                ) : null
                }
                {this.state.add_include_alert_confirm ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.AddDefaultInclusition()}
                        onCancel={() =>
                            this.setState({
                                add_include_alert_confirm: false,
                            })
                        }
                    >
                        You really want to add {this.state.selectedIncludeCategory.label} Inclusitions
                    </SweetAlert>
                ) : null}

                {this.state.add_include_success_confirm ? (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ add_include_success_confirm: false, add_include_alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                ) : null
                }
            </React.Fragment>
        );
    }
}

export default ItineraryFooter;
